/* NE2 Quiz — in-page anchor links land below the theme header. */
(function () {
  function headerHeight() {
    var header = document.querySelector('.ne-header') || document.querySelector('.header');
    return header ? header.offsetHeight : 0;
  }

  function setOffset() {
    document.documentElement.style.setProperty('--ne2q-anchor-offset', headerHeight() + 'px');
  }
  setOffset();
  window.addEventListener('resize', setOffset);

  function scrollToSection(target, smooth) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: window.scrollY + target.getBoundingClientRect().top - headerHeight(),
      behavior: smooth && !reduce ? 'smooth' : 'auto'
    });
  }

  // Sections marked data-ne2q-start="hidden" stay out of the page until started.
  function reveal(target) {
    if (target.dataset.ne2qStart !== 'hidden' || target.classList.contains('is-revealed')) return false;
    target.classList.add('is-revealed');
    // Okendo measures itself on mount, so let it re-measure now it has a size.
    window.dispatchEvent(new Event('resize'));
    return true;
  }

  function goTo(target, smooth) {
    if (reveal(target)) {
      // Wait for the reveal to lay out before measuring the scroll target.
      requestAnimationFrame(function () {
        scrollToSection(target, smooth);
      });
      return;
    }
    scrollToSection(target, smooth);
  }

  // Clicks write the hash, so the button and a pasted #ne2-quiz URL behave alike.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.ne2q a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    if (location.hash.slice(1) !== id) history.pushState(null, '', '#' + id);
    goTo(target, true);
  });

  function fromHash(smooth) {
    var target = location.hash && document.getElementById(location.hash.slice(1));
    if (target && target.classList.contains('ne2q-section')) goTo(target, smooth);
  }

  // Editing the hash on an open page, plus browser back and forward.
  window.addEventListener('hashchange', function () {
    fromHash(true);
  });

  // Links from ads or emails such as /pages/wellness-quiz#ne2-quiz or ?quiz=1.
  if (!location.hash && /[?&]quiz=1(&|$)/.test(location.search)) {
    var quiz = document.querySelector('.ne2q-embed');
    if (quiz) {
      reveal(quiz);
      window.addEventListener('load', function () {
        scrollToSection(quiz, false);
      });
    }
  } else if (location.hash) {
    var landing = document.getElementById(location.hash.slice(1));
    if (landing && landing.classList.contains('ne2q-section')) {
      reveal(landing);
      window.addEventListener('load', function () {
        scrollToSection(landing, false);
      });
    }
  }
})();
